import React from 'react'
import { Box } from '@mui/material'
import Txt from './Txt'
import { OptionGroup } from '../utils/category'
import { appPrimary } from '../utils/theme'

const sxBanner = {
	bgcolor: 'white',
	border: '1px solid #e0e0e0',
	borderLeft: `4px solid ${appPrimary}`,
	borderRadius: '0.5rem',
	p: '0.625rem 1rem',
	mb: '1rem',
} as const
const sxRow = {
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: '0.5rem',
} as const
const sxText = { flex: 1, minWidth: 0 } as const

// The banner above an option group's options: its name.
const OptionGroupHeader = React.memo(
	({ optionGroup }: { optionGroup: OptionGroup }): JSX.Element => {
		return (
			<Box sx={sxBanner}>
				<Box sx={sxRow}>
					<Box sx={sxText}>
						<Txt variant="h6" fontWeight="bold">
							{optionGroup.name}
						</Txt>
					</Box>
				</Box>
			</Box>
		)
	}
)

OptionGroupHeader.displayName = 'OptionGroupHeader'

export default OptionGroupHeader
